import script from "./NotificationModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationModal.vue?vue&type=script&setup=true&lang=ts"

import "./NotificationModal.vue?vue&type=style&index=0&id=1d66fcc9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d66fcc9"]])

export default __exports__